import type { ECharacterGender } from './character.interface';
import type { Background } from './characters.interface';

export enum EChatbotCreateStatus {
  CREATE = 'create',
  EDIT = 'edit',
  PREVIEW = 'preview',
}

export enum EChatbotVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum EModerationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface IChatbotCreatePayload {
  avatarImageId: string;
  name: string;
  descriptions: Record<string, string>;
  authorsNote?: Record<string, string>;
  exampleDialogue: string;
  gender: ECharacterGender;
  greetings: IGreetingBody[];
  scenario: string;
  tags: string[];
  /** Personality */
  traits: string;
  backgrounds: Background[];
  defaultModelId: string;
  defaultPromptId: string;
  visibility: EChatbotVisibility;
}

export interface IGreetingBody {
  title: string;
  content: string;
  background?: string;
  isDefault: boolean;
  language: string;
  backgroundImageId?: string;
  chatBackground?: string;
}

export interface IChatbotCreateResponse {
  id: string;
  name: string;
  slug: string;
  characterUrl: string;
  photo: string;
  thumb: string;
  descriptions: Record<string, string>;
  greetings: IGreetingBody[];
  traits: string;
  exampleDialogue: string;
  scenario: string;
  tags: string[];

  // Счетчики
  chatCount: number;
  favoriteCount: number;
  likeCount: number;
  dislikeCount: number;
  shareCount: number;
  memoryCount: number;
  genPictureCount: number;

  // Булевые флаги для пользователя
  isFavorite: boolean;
  isLiked: boolean;
  isDisliked: boolean;
  isNsfw: boolean;
  featured: boolean;

  // Информация о пользователе
  userId: string;
  userName: string;

  // Даты
  gmtCreate: Date;
  gmtModified: Date;

  // Настройки
  visibility: EChatbotVisibility;
  gender: ECharacterGender;
  defaultPromptId: string;
  rootCharacterId: string;
  versionNumber: number;

  // Статусы и права
  isApproved: boolean;
  isLatestPublic: boolean;
  changelog: string;

  // Видимость полей
  traitsVisibility: string;
  scenarioVisibility: string;
  exampleDialogueVisibility: string;

  // Модерация и рейтинг
  rating: string;
  moderationStatus: EModerationStatus;
}

export interface IChatbotUpdateResponse {
  slug: string;
}
